// Copied from packages/search/search-dialog/src/icons/square-return-icon.tsx

import React from 'react';

export const TalentSearchResultIcon = (): React.JSX.Element => (
	<svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#clip0_2321_14935)">
			<g clipPath="url(#clip1_2321_14935)">
				<g clipPath="url(#clip2_2321_14935)">
					<path
						d="M0 8.10156C0 3.68328 3.58172 0.101562 8 0.101562H24C28.4183 0.101562 32 3.68328 32 8.10156V24.1016C32 28.5198 28.4183 32.1016 24 32.1016H8C3.58172 32.1016 0 28.5198 0 24.1016V8.10156Z"
						fill="#FB9700"
					/>
					<path
						d="M16.5762 5.00928L19.6123 11.7729L26.9834 12.5708L27.3369 13.6597L21.8418 18.6372L23.3623 25.8931L22.4355 26.5669L16.0039 22.8784L9.57227 26.5669L8.64551 25.8931L10.165 18.6372L4.66992 13.6597L5.02441 12.5708L12.3955 11.7729L15.4316 5.00928H16.5762ZM15.9082 16.9458C14.5408 16.946 13.4326 18.0549 13.4326 19.4224V20.3267C14.1301 20.7301 14.9385 20.964 15.8008 20.9702H15.8711C16.794 20.9636 17.6552 20.696 18.3848 20.2388V19.4224C18.3848 18.0548 17.2758 16.9458 15.9082 16.9458ZM15.9082 12.4341C14.8828 12.4342 14.0519 13.2651 14.0518 14.2905C14.0518 15.3161 14.8827 16.1478 15.9082 16.1479C16.9339 16.1479 17.7656 15.3162 17.7656 14.2905C17.7655 13.265 16.9338 12.4341 15.9082 12.4341Z"
						fill="#101214"
					/>
				</g>
			</g>
		</g>
		<defs>
			<clipPath id="clip0_2321_14935">
				<rect width="32" height="32" fill="white" transform="translate(0 0.101562)" />
			</clipPath>
			<clipPath id="clip1_2321_14935">
				<rect width="32" height="32" fill="white" transform="translate(0 0.101562)" />
			</clipPath>
			<clipPath id="clip2_2321_14935">
				<path
					d="M0 8.10156C0 3.68328 3.58172 0.101562 8 0.101562H24C28.4183 0.101562 32 3.68328 32 8.10156V24.1016C32 28.5198 28.4183 32.1016 24 32.1016H8C3.58172 32.1016 0 28.5198 0 24.1016V8.10156Z"
					fill="white"
				/>
			</clipPath>
		</defs>
	</svg>
);
